import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem, Divider, CircularProgress, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogActions, } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DataTable from "../components/DataTable";
import { webEndPoint } from '../constants/globalConstants';
import { makeRequest } from "../services/api";
import SnackbarAlert from "../components/SnackbarAlert";
export default function EstimateEntry() {
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [search, setSearch] = useState("");
    const [productCategory, setProductCategory] = useState([]);
    const [productList, setProductList] = useState({});
    const [editState, setEditState] = useState(null);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);
    const [salesId, setSalesId] = useState("");
    const [salesDate, setSalesDate] = useState(new Date().toISOString().split("T")[0]);
    const [gstAmount, setGstAmount] = useState(0);
    const [customerName, setCustomerName] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [subTotal, setSubTotal] = useState(0);
    const [deduction, setDeduction] = useState(0);
    const [deductionRemarks, setDeductionRemarks] = useState("");
    const [totalWeight, setTotalWeight] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [openPreview, setOpenPreview] = useState(false);
    const [purchaseItems, setPurchaseItems] = useState([]);
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [products, setProducts] = useState([{ category: "", productName: "", qty: 1, weight: 0, price: 0, making: 0, stone: 0, amount: 0, productDetails: null },]);
    useEffect(() => {
        setSalesId(`EST-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
    }, []);
    useEffect(() => {
        calculateTotals();
    }, [products, deduction]);
    useEffect(() => {
        fetchPurchaseData();
    }, []);
    const fetchPurchaseData = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "product-estimate";
            const response = await makeRequest("get", url);
            if (response) {
                setDataSource(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
        setLoading(true);
        try {
            let url = webEndPoint + "productcategory";
            const response = await makeRequest("get", url);
            if (response) {
                setProductCategory(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const calculateTotals = () => {
        let weight = 0;
        let subtotal = 0;
        products.forEach((item) => {
            weight += Number(item.weight || 0);
            subtotal += Number(item.amount || 0);
        });
        const gst = (subtotal * 3) / 100;
        const grandTotal = subtotal;
        setTotalWeight(weight);
        setSubTotal(subtotal);
        setGstAmount(gst);
        setTotalAmount(grandTotal);
    };
    const addProductRow = () => {
        setProducts([...products, { category: "", productName: "", qty: 1, weight: "", price: "", making: "", stone: "", amount: 0, },]);
    };
    const removeProductRow = (index) => {
        const updated = [...products];
        updated.splice(index, 1);
        setProducts(updated);
    };
    const handleProductChange = (index, field, value) => {
        const updated = [...products];
        updated[index][field] = ["qty", "weight", "price"].includes(field) ? Number(value) : value;
        if (field === "category") {
            updated[index].productName = "";
            fetchProductsByCategory(value, index);
        }
        if (field === "productName") {
            const selectedProduct =
                productList[index]?.find(
                    p => p.rfId === value
                );
            if (selectedProduct) {
                updated[index].weight =
                    Number(
                        selectedProduct.net_weight ||
                        selectedProduct.weight ||
                        0
                    );
                updated[index].price = Number(selectedProduct.price || selectedProduct.rate_per_gram || 0);
                updated[index].productDetails = selectedProduct;
            }
        }
        const qty = Number(updated[index].qty) || 0;
        const weight = Number(updated[index].weight) || 0;
        const price = Number(updated[index].price) || 0;
        const making = Number(updated[index].making) || 0;
        const stone = Number(updated[index].stone) || 0;
        updated[index].amount = (qty * weight * price) + (making + stone);
        setProducts(updated);
        calculateTotals(updated);
    };
    const handleSave = async () => {
        if (!customerName?.trim()) {
            setMessage("Customer Name is required");
            setSnackbar(true);
            return;
        }
        if (!mobileNo?.trim()) {
            setMessage("Mobile Number is required");
            setSnackbar(true);
            return;
        }
        if (!/^[0-9]{10}$/.test(mobileNo)) {
            setMessage("Please enter a valid 10-digit Mobile Number");
            setSnackbar(true);
            return;
        }
        if (!salesDate) {
            setMessage("Estimate Date is required");
            setSnackbar(true);
            return;
        }
        if (!products || products.length === 0) {
            setMessage("Please add at least one product");
            setSnackbar(true);
            return;
        }
        for (const item of products) {
            if (!item.productName) {
                setMessage("Please select Product");
                setSnackbar(true);
                return;
            }
            if (!item.qty || Number(item.qty) <= 0) {
                setMessage("Please enter valid Quantity");
                setSnackbar(true);
                return;
            }
            if (!item.weight || Number(item.weight) <= 0) {
                setMessage("Please enter valid Weight");
                setSnackbar(true);
                return;
            }
            if (!item.price || Number(item.price) <= 0) {
                setMessage("Please enter valid Rate");
                setSnackbar(true);
                return;
            }
            if (!item.amount || Number(item.amount) <= 0) {
                setMessage("Please enter valid Amount");
                setSnackbar(true);
                return;
            }
        }
        if (!totalAmount || Number(totalAmount) <= 0) {
            setMessage("Total Amount should be greater than 0");
            setSnackbar(true);
            return;
        }
        try {
            setLoading(true);
            const salesPayload = {
                estimate_no: salesId,
                customer_id: "",
                customer_name: customerName,
                customer_mobile: mobileNo,
                estimate_date: salesDate,
                total_product_amount: 0,
                total_making_charges: 0,
                total_gst_amount: gstAmount,
                discount_amount: 0,
                grand_total: totalAmount,
                payment_mode: "CASH",
                payment_status: "SUCCESS",
                razorpay_payment_id: "",
                estimate_status: "CONFIRMED",
                notes: deductionRemarks,
                isActive: 0
            };
            const salesResponse = await makeRequest("post", webEndPoint + "product-estimate", salesPayload);
            const estimate_id = salesResponse.data.rfId;
            for (const item of products) {
                const itemAmount = Number(item.amount || 0);
                const gst = itemAmount * 0.03;
                const salesItemPayload = {
                    estimate_id,
                    product_id: item.productName,
                    qty: item.qty || 1,
                    gross_weight: item.weight || 0,
                    net_weight: item.weight || 0,
                    rate_per_gram: item.price || 0,
                    metal_amount: itemAmount,
                    making_charges: item.making || 0,
                    wastage_amount: item.stone,
                    gst_percent: 3,
                    gst_amount: gst,
                    total_amount: itemAmount
                };
                await makeRequest("post", webEndPoint + "product-estimate-item", salesItemPayload);
            }
            setMessage("Estimates Saved Successfully");
            setSnackbar(true);
            resetForm();
            setOpen(false);
            fetchPurchaseData();
        } catch (err) {
            console.error(err);
            setMessage(err?.response?.data?.message || err.message);
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const fetchProductsByCategory = async (categoryId, index) => {
        setLoading(true);
        try {
            let url = webEndPoint + "billing-products/category/" + categoryId;
            const response = await makeRequest("get", url);
            if (response) {
                setProductList(prev => ({ ...prev, [index]: response.data }));
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };
    const resetForm = () => {
        setSalesId(`EST-${new Date().getFullYear()}-${Date.now().toString().slice(-4)}`);
        setSalesDate(new Date().toISOString().split("T")[0]);
        setCustomerName("");
        setMobileNo("");
        setSubTotal(0);
        setGstAmount(0);
        setTotalWeight(0);
        setTotalAmount(0);
        setProducts([{ category: "", productName: "", qty: 1, weight: "", price: "", making: "", stone: "", amount: 0, productDetails: null }]);
    };
    const openAdd = () => {
        setEditState(null);
        resetForm();
        setOpen(true);
    };
    const openEdit = (data) => {
        setEditState(data);
        // setCategory(data?.product_category_id);
        // setProductName(data?.product_name);
        setOpen(true);
    };
    const formatDateTime = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        let hours = d.getHours();
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        return `${day}-${month}-${year}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
    };
    const formatDate = (date) => {
        return new Date(date).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        });
    };
    const handleViewPurchase = async (row) => {
        try {
            setLoading(true);
            setSelectedPurchase(row);
            const response = await makeRequest("get", webEndPoint + "product-estimate-item/sales/" + row.rfId);
            if (response) {
                setPurchaseItems(response?.data || []);
                setOpenPreview(true);
            }
        } catch (err) {
            console.error(err);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const downloadInvoice = async (salesId) => {
        try {
            setLoading(true);
            const response = await makeRequest("get", webEndPoint + "product-estimate/invoice/" + salesId);
            if (response?.url) {
                window.open(response.url, "_blank");
            }
        } catch (error) {
            console.error("Invoice download failed:", error);
            setMessage("Failed to load purchase items");
            setSnackbar(true);
        } finally {
            setLoading(false);
        }
    };
    const filteredState = dataSource?.filter((d) =>
        d?.customer_name?.toLowerCase().includes(search?.toLowerCase()) || d?.customer_mobile?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "Estimate No", "Date", "Customer", "Mobile", "Total Amount", "Action"];
    const rows = filteredState?.map((item, index) => [index + 1, item?.rfId, formatDate(item?.estimate_date), item?.customer_name, item?.customer_mobile, `₹ ${item.grand_total?.toLocaleString()}`,
    <Box>
        <Tooltip title="Preview">
            <IconButton color="info" onClick={() => handleViewPurchase(item)}><VisibilityIcon /></IconButton>
        </Tooltip>
        <Tooltip title="PDF">
            <IconButton color="primary" onClick={() => downloadInvoice(item?.rfId)}><PrintIcon /></IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Estimate Bill</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search Customer Name / Mobile Number" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Create Estimate Bill</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box component="div" sx={{ position: "fixed", top: 60, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: "90%", height: "80%", display: "flex", overflow: "hidden", gap: 2 }}>
                        <Box sx={{ width: "25%", display: "flex", flexDirection: "column", gap: 2, height: "100%", overflowY: "auto", pr: 1, borderRight: "1px solid #e0e0e0" }}>
                            <Typography variant="h6" fontWeight={600}>Estimate Details</Typography>
                            <Divider />
                            <TextField label="Estimate ID" value={salesId} disabled fullWidth />
                            <TextField label="Estimate Date" type="date" value={salesDate}
                                onChange={(e) => setSalesDate(e.target.value)} InputLabelProps={{ shrink: true, }}
                                fullWidth />
                            <TextField label="Customer Name" value={customerName} onChange={(e) => setCustomerName(e.target.value)} fullWidth />
                            <TextField label="Mobile Number" value={mobileNo} onChange={(e) => setMobileNo(e.target.value)} fullWidth />
                            <TextField label="Other Details" value={deductionRemarks} onChange={(e) => setDeductionRemarks(e.target.value)} multiline rows={4} fullWidth />
                            <TextField label="Sub Total" value={subTotal} disabled fullWidth />
                            {/* <TextField label="GST (3%)" value={gstAmount.toFixed(2)} disabled fullWidth /> */}
                            {/* <TextField label="Deduction" type="number" value={deduction} onChange={(e) => setDeduction(e.target.value)} fullWidth /> */}
                            <TextField label="Total Weight" value={totalWeight} disabled fullWidth />
                            <TextField label="Total Amount" value={totalAmount} disabled fullWidth />
                        </Box>
                        <Box sx={{ width: "75%", height: "100%", overflowY: "auto", pl: 1, display: "flex", flexDirection: "column" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, }}>
                                <Typography variant="h6" fontWeight={600}>Product Details</Typography>
                                <Button variant="contained" startIcon={<AddIcon />} onClick={addProductRow}>Add Product</Button>
                            </Box>
                            <Divider sx={{ mb: 2 }} />
                            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, fontWeight: 600, }}>
                                <Typography>Category</Typography>
                                <Typography>Product</Typography>
                                <Typography>Qty</Typography>
                                <Typography>Weight (Gram)</Typography>
                                <Typography>Price (Gram)</Typography>
                                <Typography>Making</Typography>
                                <Typography>Stone Rate</Typography>
                                <Typography>Amount</Typography>
                                <Typography></Typography>
                            </Box>
                            {products.map(
                                (item, index) => (
                                    <Box key={index} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 0.8fr 0.8fr 0.8fr 1fr 1fr 1fr 60px", gap: 1, mb: 2, }}>
                                        <TextField select size="small" value={item.category}
                                            onChange={(e) => handleProductChange(index, "category", e.target.value)}>
                                            {productCategory?.map((cat) => (<MenuItem key={cat?.rfId} value={cat?.rfId}>{cat?.category_name}</MenuItem>))}
                                        </TextField>
                                        <TextField select size="small" value={item.productName}
                                            onChange={(e) => handleProductChange(index, "productName", e.target.value)}>
                                            {productList[index]?.map((item) => (<MenuItem key={item.rfId} value={item.rfId}>{item.product_name}</MenuItem>))}
                                        </TextField>
                                        <TextField size="small" type="number" value={item.qty}
                                            onChange={(e) => handleProductChange(index, "qty", e.target.value)} />
                                        <TextField size="small" type="number" value={item.weight}
                                            onChange={(e) => handleProductChange(index, "weight", e.target.value)} />
                                        <TextField size="small" type="number" value={item.price}
                                            onChange={(e) => handleProductChange(index, "price", e.target.value)} />
                                        <TextField size="small" type="number" value={item.making}
                                            onChange={(e) => handleProductChange(index, "making", e.target.value)} />
                                        <TextField size="small" type="number" value={item.stone}
                                            onChange={(e) => handleProductChange(index, "stone", e.target.value)} />
                                        <TextField size="small" value={item.amount} disabled />
                                        <IconButton color="error" onClick={() => removeProductRow(index)}><DeleteIcon /></IconButton>
                                    </Box>
                                )
                            )}
                            <Box sx={{ position: "sticky", bottom: 0, backgroundColor: "#fff", borderTop: "1px solid #e0e0e0", pt: 2, mt: 2, display: "flex", justifyContent: "flex-end", gap: 2, zIndex: 10 }}>
                                <Button variant="outlined" color="error" size="large" onClick={() => setOpen(false)}>Close</Button>
                                <Button variant="contained" size="large" onClick={handleSave}>Generate Estimate Bill</Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
            <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ fontWeight: 600, fontSize: 24 }}>Purchase Details</DialogTitle>
                <DialogContent>
                    <Paper elevation={0} sx={{ p: 2, mb: 3, background: "#f8f8f8" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Estimate No</Typography>
                                <Typography>{selectedPurchase?.rfId}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Customer Name</Typography>
                                <Typography>{selectedPurchase?.customer_name}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Mobile Number</Typography>
                                <Typography>{selectedPurchase?.customer_mobile}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Sales Date</Typography>
                                <Typography>{formatDate(selectedPurchase?.estimate_date)}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography fontWeight={600}>Total Amount</Typography>
                                <Typography>₹ {Number(selectedPurchase?.grand_total || 0).toLocaleString()}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Typography fontWeight={600}>Other Deatils</Typography>
                    <Typography>{selectedPurchase?.notes}</Typography><br />
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">#</TableCell>
                                    <TableCell>Product</TableCell>
                                    <TableCell align="center">Qty</TableCell>
                                    <TableCell align="right">Weight</TableCell>
                                    <TableCell align="right">Rate</TableCell>
                                    <TableCell align="right">Making</TableCell>
                                    <TableCell align="right">Stone</TableCell>
                                    <TableCell align="right">Amount</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {purchaseItems?.map((item, index) => (
                                    <TableRow key={item?.rfId}>
                                        <TableCell align="center">{index + 1}</TableCell>
                                        <TableCell>{item?.product_name}</TableCell>
                                        <TableCell align="center">{item?.qty}</TableCell>
                                        <TableCell align="right">{Number(item?.net_weight).toFixed(3)}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.rate_per_gram).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.making_charges).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.wastage_amount).toLocaleString()}</TableCell>
                                        <TableCell align="right">₹ {Number(item?.total_amount).toLocaleString()}</TableCell>
                                    </TableRow>
                                )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setOpenPreview(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}